import React from 'react';
import { Box, Flex, Heading, Stack, Text, useColorModeValue } from '@chakra-ui/react';

export function PageShell({
  children,
  maxW = '100%',
  pt = { base: '130px', md: '100px', xl: '100px' },
  pb = { base: 16, md: 20 },
  px = { base: 4, md: 6, xl: 8 },
}) {
  return (
    <Box pt={pt} pb={pb} px={px}>
      <Box maxW={maxW} w="100%" mx="auto">
        {children}
      </Box>
    </Box>
  );
}

export function PageHeader({ title, description, actions = null }) {
  const mutedText = useColorModeValue('gray.600', 'gray.300');
  const titleColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex
      justify="space-between"
      align={{ base: 'flex-start', md: 'center' }}
      gap={4}
      flexWrap="wrap"
    >
      <Stack spacing={1} minW={0}>
        <Heading
          size="lg"
          color={titleColor}
          letterSpacing="-0.03em"
          fontWeight="800"
        >
          {title}
        </Heading>
        {description ? (
          <Text color={mutedText} fontSize={{ base: 'sm', md: 'md' }} maxW="78ch">
            {description}
          </Text>
        ) : null}
      </Stack>
      {actions ? <Box w={{ base: '100%', md: 'auto' }}>{actions}</Box> : null}
    </Flex>
  );
}

export default PageShell;
